class InterviewSliderSwiper {
  constructor(root) {
    this.root = typeof root === 'string' ? document.querySelector(root) : root;
    this.swiper = null;
    this.onImagesReady = this.onImagesReady.bind(this);
    this.onResize = this.onResize.bind(this);

    if (!this.root || typeof Swiper === 'undefined') {
      return;
    }

    if (!this.shouldUseSwiper(this.getSlideCount())) {
      return;
    }

    this.init();

    if (document.readyState === 'complete') {
      this.onImagesReady();
    } else {
      window.addEventListener('load', this.onImagesReady, { once: true });
    }
  }

  getSpaceBetweenPx() {
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    if (Number.isNaN(rootFontSize)) {
      return 20;
    }

    return window.matchMedia('(max-width: 767px)').matches
      ? rootFontSize * 1.6
      : rootFontSize * 2;
  }

  getSlideCount() {
    const dataCount = parseInt(this.root.dataset.slideCount, 10);

    if (!Number.isNaN(dataCount) && dataCount > 0) {
      return dataCount;
    }

    return this.root.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
  }

  isLoopEnabled() {
    return this.root.dataset.swiperLoop !== 'false';
  }

  isAutoplayEnabled() {
    return this.root.dataset.swiperAutoplay === 'true';
  }

  shouldUseSwiper(slideCount) {
    return slideCount > 5;
  }

  onImagesReady() {
    if (!this.swiper) {
      return;
    }

    this.swiper.update();
  }

  onResize() {
    if (!this.swiper || this.swiper.destroyed) {
      return;
    }

    this.swiper.params.spaceBetween = this.getSpaceBetweenPx();
    this.swiper.update();
  }

  init() {
    const container = this.root.closest('.c-interview-slider__wrap');
    const prevEl = container ? container.querySelector('.c-interview-slider__control--prev') : null;
    const nextEl = container ? container.querySelector('.c-interview-slider__control--next') : null;
    const slideCount = this.getSlideCount();

    if (!this.shouldUseSwiper(slideCount)) {
      return;
    }

    const useLoop = this.isLoopEnabled();
    const useAutoplay = this.isAutoplayEnabled();

    this.swiper = new Swiper(this.root, {
      slidesPerView: 'auto',
      spaceBetween: this.getSpaceBetweenPx(),
      loop: useLoop,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      allowTouchMove: true,
      touchStartPreventDefault: false,
      navigation:
        prevEl && nextEl
          ? {
              prevEl,
              nextEl,
            }
          : undefined,
      autoplay: useAutoplay
        ? {
            delay: 4000,
            disableOnInteraction: false,
          }
        : false,
    });

    requestAnimationFrame(() => {
      if (this.swiper) {
        this.swiper.update();
      }
    });

    window.addEventListener('resize', this.onResize);
  }
}
